module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "login-image-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-bg-input-area"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitByMode(_vm.username.trim(), _vm.password)
      },
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submitByMode(_vm.username.trim(), _vm.password)
      }
    }
  }, [_c('div', {}, [_c('label', {
    staticClass: "login-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n              " + _vm._s((_vm.forgotPasswordMode) ? "Email" : "Username") + "\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "login-input-field",
    attrs: {
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.forgotPasswordMode) ? _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('label', {
    staticClass: "login-label",
    staticStyle: {},
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "login-input-field",
    attrs: {
      "type": "password",
      "name": "username"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.forgotPasswordMode) ? _c('div', [_c('button', {
    staticClass: "login-submit-btn primary-green-bg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login(_vm.username.trim(), _vm.password)
      }
    }
  }, [_vm._v("Login")])]) : _c('div', [_c('button', {
    staticClass: "login-submit-btn primary-green-bg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.forgotPassword(_vm.username.trim())
      }
    }
  }, [_vm._v("Reset password")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.forgotPasswordMode) ? _c('div', {
    staticClass: "login-links"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.forgotPasswordModeActivate()
      }
    }
  }, [_vm._v("Reset/Forgot Password?")])]) : _c('div', {
    staticClass: "login-links"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.forgotPasswordModeDeactivate()
      }
    }
  }, [_vm._v("Back to login")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fb2f964a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 385
// module chunks = 2